/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Lot_Not_For_ProductInputs */

const vi_error_lot_not_for_product = /** @type {(inputs: Error_Lot_Not_For_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô đã chọn không thuộc sản phẩm của dòng (có thể dòng vừa được nối lại sang sản phẩm khác). Đóng cửa sổ xuất kho, mở lại để chọn lô mới.`)
};

/**

* @param {Error_Lot_Not_For_ProductInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_lot_not_for_product = /** @type {((inputs?: Error_Lot_Not_For_ProductInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Lot_Not_For_ProductInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_lot_not_for_product(inputs)
});